<template>
	<div class="">
		<header-vue></header-vue>
		<div class="container-l2">
			<h1 class="h11">产品介绍及公司动态</h1>
			<div class="secNav secNav2 marBottom10">
				<ul>
					<li :class="{active:pid==1}" @click="changePid(1)">产品介绍</li>
					<li :class="{active:pid==2}" @click="changePid(2)">公司动态</li>
				</ul>
			</div>
			<div class="text-right margin2">
				<el-button @click="addNew()"><i class="fa fa-plus"></i> 添加</el-button>
			</div>
			<el-table
		    	stripe
				border
			    ref="multipleTable"
			    :data="userList"
			    tooltip-effect="dark"
			    style="width: 100%">
			    <el-table-column
			      prop="title"
			      label="标题">
			    </el-table-column>
			    <el-table-column
			      prop="pid"
			      label="所属类型"
			      :formatter="formatType"
			      show-overflow-tooltip>
			    </el-table-column>
			    <el-table-column
			      prop="time"
			      label="更新时间"
			      :formatter="dateFormat"
			      width="120">
			    </el-table-column>
			    <el-table-column
		          label="操作">
		          <template slot-scope="scope">
		            <el-button type="text" size="small"
		                       @click="editContent(scope.$index, scope.row)">编辑
		            </el-button>
		            <el-button type="text" size="small"
		                       @click="removeContent(scope.$index, scope.row)">移除
		            </el-button>
		          </template>
		        </el-table-column>
			  </el-table>
		</div>
		
	</div>
</template>

<script>
export default {
  name: 'app',
  data(){
    return {
    	userList:[],
    	feedback:'',
    	pid:1
    }
  },
  mounted(){
    this.$nextTick(function(){
		this.getList();
  	})
  },

  methods: {
  	formatType(row, column){
//		console.log(row);
		switch(parseInt(row.pid)){
			case 1:
				return "产品介绍";
				break;
			case 2:
				return "公司动态";
				break;
		}
		
	},
	changePid(pid){
		this.pid = pid;
		this.getList();
	},
//	移除该项
	removeContent(index,row){
		let valiCodeParams={
			uid:this.getCookie('uid'),
	  		time:Date.parse( new Date()),
	  		terminalId:4,
	  		id:row.id
  		};
  		this.sign(valiCodeParams);
  		this.$ajax.post(this.$store.state.domain+"/Home/ProductDel/ProductDel",this.$qs.stringify(valiCodeParams),{
            emulateJSON: true
        }).then(res=>{
        	if(res.data.status==1){
        		this.getList();
        		this.feedback = res.data.msg || '删除失败！';
        		this.$message.success(this.feedback);
        		
        		
        	}else if(res.data.code==10008){
			      this.delCookie('username');
					this.$router.push('/login/');
					this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);
        	}else{
        		//console.log(res.data.msg);
        	}
  		});
	},
//	渲染页面
    getList(){
		let valiCodeParams={
			uid:this.getCookie('uid'),
	  		pid:this.pid,
	  		time:Date.parse( new Date()),
	  		page:1,
	  		pagesize:9999,
	  		terminalId:4
  		};
  		this.sign(valiCodeParams);
  		this.$ajax.post(this.$store.state.domain+"/Home/ProductList/ProductList",this.$qs.stringify(valiCodeParams),{
            emulateJSON: true
        }).then(res=>{
        	if(res.data.status==1){
        		this.userList = res.data.data.data || [];
        		
        	}else if(res.data.code==10008){
			      this.delCookie('username');
					this.$router.push('/login/');
					this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);
        	}else{
        		//console.log(res.data.msg);
        	}
  		});
	},
	editContent(index,row){
		let routeUrl = this.$router.resolve({
	          path: "/news",
	          query: {
	          	content:row.content,
	          	picurl:row.picurl,
	          	title:row.title,
	          	content:row.content,
	          	pid:row.pid,
	          	id:row.id,
	          	index:index
	          }
	     });
	     window.open(routeUrl.href, '_blank');
	},
	addNew(){
		let routeUrl = this.$router.resolve({
	          path: "/news",
	     });
	     window.open(routeUrl.href, '_blank');
	}
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/productManage.vue